(function () {
  var e = {
      296: function _(e, t, r) {
        var o = /^\s+|\s+$/g,
          n = /^[-+]0x[0-9a-f]+$/i,
          i = /^0b[01]+$/i,
          c = /^0o[0-7]+$/i,
          u = parseInt,
          s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g,
          l = "object" == typeof self && self && self.Object === Object && self,
          a = s || l || Function("return this")(),
          f = Object.prototype.toString,
          p = Math.max,
          y = Math.min,
          d = function d() {
            return a.Date.now();
          };
        function b(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function h(e) {
          if ("number" == typeof e) return e;
          if (function (e) {
            return "symbol" == typeof e || function (e) {
              return !!e && "object" == typeof e;
            }(e) && "[object Symbol]" == f.call(e);
          }(e)) return NaN;
          if (b(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = b(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(o, "");
          var r = i.test(e);
          return r || c.test(e) ? u(e.slice(2), r ? 2 : 8) : n.test(e) ? NaN : +e;
        }
        e.exports = function (e, t, r) {
          var o,
            n,
            i,
            c,
            u,
            s,
            l = 0,
            a = !1,
            f = !1,
            v = !0;
          if ("function" != typeof e) throw new TypeError("Expected a function");
          function m(t) {
            var r = o,
              i = n;
            return o = n = void 0, l = t, c = e.apply(i, r);
          }
          function O(e) {
            var r = e - s;
            return void 0 === s || r >= t || r < 0 || f && e - l >= i;
          }
          function w() {
            var e = d();
            if (O(e)) return g(e);
            u = setTimeout(w, function (e) {
              var r = t - (e - s);
              return f ? y(r, i - (e - l)) : r;
            }(e));
          }
          function g(e) {
            return u = void 0, v && o ? m(e) : (o = n = void 0, c);
          }
          function P() {
            var e = d(),
              r = O(e);
            if (o = arguments, n = this, s = e, r) {
              if (void 0 === u) return function (e) {
                return l = e, u = setTimeout(w, t), a ? m(e) : c;
              }(s);
              if (f) return u = setTimeout(w, t), m(s);
            }
            return void 0 === u && (u = setTimeout(w, t)), c;
          }
          return t = h(t) || 0, b(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function () {
            void 0 !== u && clearTimeout(u), l = 0, o = s = n = u = void 0;
          }, P.flush = function () {
            return void 0 === u ? c : g(d());
          }, P;
        };
      },
      96: function _(e, t, r) {
        var o = "Expected a function",
          n = NaN,
          i = "[object Symbol]",
          c = /^\s+|\s+$/g,
          u = /^[-+]0x[0-9a-f]+$/i,
          s = /^0b[01]+$/i,
          l = /^0o[0-7]+$/i,
          a = parseInt,
          f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g,
          p = "object" == typeof self && self && self.Object === Object && self,
          y = f || p || Function("return this")(),
          d = Object.prototype.toString,
          b = Math.max,
          h = Math.min,
          v = function v() {
            return y.Date.now();
          };
        function m(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function O(e) {
          if ("number" == typeof e) return e;
          if (function (e) {
            return "symbol" == typeof e || function (e) {
              return !!e && "object" == typeof e;
            }(e) && d.call(e) == i;
          }(e)) return n;
          if (m(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = m(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(c, "");
          var r = s.test(e);
          return r || l.test(e) ? a(e.slice(2), r ? 2 : 8) : u.test(e) ? n : +e;
        }
        e.exports = function (e, t, r) {
          var n = !0,
            i = !0;
          if ("function" != typeof e) throw new TypeError(o);
          return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function (e, t, r) {
            var n,
              i,
              c,
              u,
              s,
              l,
              a = 0,
              f = !1,
              p = !1,
              y = !0;
            if ("function" != typeof e) throw new TypeError(o);
            function d(t) {
              var r = n,
                o = i;
              return n = i = void 0, a = t, u = e.apply(o, r);
            }
            function w(e) {
              var r = e - l;
              return void 0 === l || r >= t || r < 0 || p && e - a >= c;
            }
            function g() {
              var e = v();
              if (w(e)) return P(e);
              s = setTimeout(g, function (e) {
                var r = t - (e - l);
                return p ? h(r, c - (e - a)) : r;
              }(e));
            }
            function P(e) {
              return s = void 0, y && n ? d(e) : (n = i = void 0, u);
            }
            function j() {
              var e = v(),
                r = w(e);
              if (n = arguments, i = this, l = e, r) {
                if (void 0 === s) return function (e) {
                  return a = e, s = setTimeout(g, t), f ? d(e) : u;
                }(l);
                if (p) return s = setTimeout(g, t), d(l);
              }
              return void 0 === s && (s = setTimeout(g, t)), u;
            }
            return t = O(t) || 0, m(r) && (f = !!r.leading, c = (p = "maxWait" in r) ? b(O(r.maxWait) || 0, t) : c, y = "trailing" in r ? !!r.trailing : y), j.cancel = function () {
              void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
            }, j.flush = function () {
              return void 0 === s ? u : P(v());
            }, j;
          }(e, t, {
            leading: n,
            maxWait: t,
            trailing: i
          });
        };
      },
      703: function _(e, t, r) {
        "use strict";

        var o = r(414);
        function n() {}
        function i() {}
        i.resetWarningCache = n, e.exports = function () {
          function e(e, t, r, n, i, c) {
            if (c !== o) {
              var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw u.name = "Invariant Violation", u;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var r = {
            array: e,
            bigint: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: i,
            resetWarningCache: n
          };
          return r.PropTypes = r, r;
        };
      },
      697: function _(e, t, r) {
        e.exports = r(703)();
      },
      414: function _(e) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }
    },
    t = {};
  function r(o) {
    var n = t[o];
    if (void 0 !== n) return n.exports;
    var i = t[o] = {
      exports: {}
    };
    return e[o](i, i.exports, r), i.exports;
  }
  r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, {
      a: t
    }), t;
  }, r.d = function (e, t) {
    for (var o in t) r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
      enumerable: !0,
      get: t[o]
    });
  }, r.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var o = {};
  (function () {
    "use strict";

    r.r(o), r.d(o, {
      LazyLoadComponent: function LazyLoadComponent() {
        return A;
      },
      LazyLoadImage: function LazyLoadImage() {
        return ce;
      },
      trackWindowScroll: function trackWindowScroll() {
        return M;
      }
    });
    var e = require("react");
    var t = r.n(e),
      n = r(697);
    var i = require("react-dom");
    var c = r.n(i);
    function u() {
      return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
    }
    function s(e) {
      return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, s(e);
    }
    function l(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, o);
      }
      return r;
    }
    function a(e, t, r) {
      return (t = p(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function f(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, p(o.key), o);
      }
    }
    function p(e) {
      var t = function (e, t) {
        if ("object" !== s(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
          var o = r.call(e, "string");
          if ("object" !== s(o)) return o;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" === s(t) ? t : String(t);
    }
    function y(e, t) {
      return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, y(e, t);
    }
    function d(e) {
      return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, d(e);
    }
    var b = function b(e) {
        e.forEach(function (e) {
          e.isIntersecting && e.target.onVisible();
        });
      },
      h = {},
      v = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && y(e, t);
        }(v, e);
        var r,
          o,
          n,
          i,
          p = (n = v, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = d(n);
            if (i) {
              var r = d(this).constructor;
              e = Reflect.construct(t, arguments, r);
            } else e = t.apply(this, arguments);
            return function (e, t) {
              if (t && ("object" === s(t) || "function" == typeof t)) return t;
              if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
              return function (e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }(e);
            }(this, e);
          });
        function v(e) {
          var t;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, v), (t = p.call(this, e)).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && u(), t.supportsObserver) {
            var r = e.threshold;
            t.observer = function (e) {
              return h[e] = h[e] || new IntersectionObserver(b, {
                rootMargin: e + "px"
              }), h[e];
            }(r);
          }
          return t;
        }
        return r = v, o = [{
          key: "componentDidMount",
          value: function value() {
            this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.supportsObserver || this.updateVisibility();
          }
        }, {
          key: "getPlaceholderBoundingBox",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition,
              t = this.placeholder.getBoundingClientRect(),
              r = c().findDOMNode(this.placeholder).style,
              o = parseInt(r.getPropertyValue("margin-left"), 10) || 0,
              n = parseInt(r.getPropertyValue("margin-top"), 10) || 0;
            return {
              bottom: e.y + t.bottom + n,
              left: e.x + t.left + o,
              right: e.x + t.right + o,
              top: e.y + t.top + n
            };
          }
        }, {
          key: "isPlaceholderInViewport",
          value: function value() {
            if ("undefined" == typeof window || !this.placeholder) return !1;
            var e = this.props,
              t = e.scrollPosition,
              r = e.threshold,
              o = this.getPlaceholderBoundingBox(t),
              n = t.y + window.innerHeight,
              i = t.x,
              c = t.x + window.innerWidth,
              u = t.y;
            return Boolean(u - r <= o.bottom && n + r >= o.top && i - r <= o.right && c + r >= o.left);
          }
        }, {
          key: "updateVisibility",
          value: function value() {
            this.isPlaceholderInViewport() && this.props.onVisible();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              r = this.props,
              o = r.className,
              n = r.height,
              i = r.placeholder,
              c = r.style,
              u = r.width;
            if (i && "function" != typeof i.type) return t().cloneElement(i, {
              ref: function ref(t) {
                return e.placeholder = t;
              }
            });
            var s = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? l(Object(r), !0).forEach(function (t) {
                  a(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }
              return e;
            }({
              display: "inline-block"
            }, c);
            return void 0 !== u && (s.width = u), void 0 !== n && (s.height = n), t().createElement("span", {
              className: o,
              ref: function ref(t) {
                return e.placeholder = t;
              },
              style: s
            }, i);
          }
        }], o && f(r.prototype, o), Object.defineProperty(r, "prototype", {
          writable: !1
        }), v;
      }(t().Component);
    v.propTypes = {
      onVisible: n.PropTypes.func.isRequired,
      className: n.PropTypes.string,
      height: n.PropTypes.oneOfType([n.PropTypes.number, n.PropTypes.string]),
      placeholder: n.PropTypes.element,
      threshold: n.PropTypes.number,
      useIntersectionObserver: n.PropTypes.bool,
      scrollPosition: n.PropTypes.shape({
        x: n.PropTypes.number.isRequired,
        y: n.PropTypes.number.isRequired
      }),
      width: n.PropTypes.oneOfType([n.PropTypes.number, n.PropTypes.string])
    }, v.defaultProps = {
      className: "",
      placeholder: null,
      threshold: 100,
      useIntersectionObserver: !0
    };
    var m = v;
    var O = r(296),
      w = r.n(O),
      g = r(96),
      P = r.n(g),
      j = function j(e) {
        var t = getComputedStyle(e, null);
        return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
      };
    var T = function T(e) {
      if (!(e instanceof HTMLElement)) return window;
      for (var t = e; t && t instanceof HTMLElement;) {
        if (/(scroll|auto)/.test(j(t))) return t;
        t = t.parentNode;
      }
      return window;
    };
    function S(e) {
      return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, S(e);
    }
    var E = ["delayMethod", "delayTime"];
    function L() {
      return L = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
        return e;
      }, L.apply(this, arguments);
    }
    function _(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (void 0, n = function (e, t) {
          if ("object" !== S(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var o = r.call(e, "string");
            if ("object" !== S(o)) return o;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(o.key), "symbol" === S(n) ? n : String(n)), o);
      }
      var n;
    }
    function I(e, t) {
      return I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, I(e, t);
    }
    function x(e, t) {
      if (t && ("object" === S(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return R(e);
    }
    function R(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function k(e) {
      return k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, k(e);
    }
    var D = function D() {
        return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
      },
      C = function C() {
        return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
      };
    var M = function M(e) {
      var r = function (r) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && I(e, t);
        }(a, r);
        var o,
          n,
          i,
          s,
          l = (i = a, s = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
              t = k(i);
            if (s) {
              var r = k(this).constructor;
              e = Reflect.construct(t, arguments, r);
            } else e = t.apply(this, arguments);
            return x(this, e);
          });
        function a(e) {
          var r;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (r = l.call(this, e)).useIntersectionObserver = e.useIntersectionObserver && u(), r.useIntersectionObserver) return x(r);
          var o = r.onChangeScroll.bind(R(r));
          return "debounce" === e.delayMethod ? r.delayedScroll = w()(o, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = P()(o, e.delayTime)), r.state = {
            scrollPosition: {
              x: D(),
              y: C()
            }
          }, r.baseComponentRef = t().createRef(), r;
        }
        return o = a, (n = [{
          key: "componentDidMount",
          value: function value() {
            this.addListeners();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.removeListeners();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            "undefined" == typeof window || this.useIntersectionObserver || T(c().findDOMNode(this.baseComponentRef.current)) !== this.scrollElement && (this.removeListeners(), this.addListeners());
          }
        }, {
          key: "addListeners",
          value: function value() {
            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = T(c().findDOMNode(this.baseComponentRef.current)), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
              passive: !0
            }), window.addEventListener("resize", this.delayedScroll, {
              passive: !0
            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
              passive: !0
            }));
          }
        }, {
          key: "removeListeners",
          value: function value() {
            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
          }
        }, {
          key: "onChangeScroll",
          value: function value() {
            this.useIntersectionObserver || this.setState({
              scrollPosition: {
                x: D(),
                y: C()
              }
            });
          }
        }, {
          key: "render",
          value: function value() {
            var r = this.props,
              o = (r.delayMethod, r.delayTime, function (e, t) {
                if (null == e) return {};
                var r,
                  o,
                  n = function (e, t) {
                    if (null == e) return {};
                    var r,
                      o,
                      n = {},
                      i = Object.keys(e);
                    for (o = 0; o < i.length; o++) r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                    return n;
                  }(e, t);
                if (Object.getOwnPropertySymbols) {
                  var i = Object.getOwnPropertySymbols(e);
                  for (o = 0; o < i.length; o++) r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                }
                return n;
              }(r, E)),
              n = this.useIntersectionObserver ? null : this.state.scrollPosition;
            return t().createElement(e, L({
              forwardRef: this.baseComponentRef,
              scrollPosition: n
            }, o));
          }
        }]) && _(o.prototype, n), Object.defineProperty(o, "prototype", {
          writable: !1
        }), a;
      }(t().Component);
      return r.propTypes = {
        delayMethod: n.PropTypes.oneOf(["debounce", "throttle"]),
        delayTime: n.PropTypes.number,
        useIntersectionObserver: n.PropTypes.bool
      }, r.defaultProps = {
        delayMethod: "throttle",
        delayTime: 300,
        useIntersectionObserver: !0
      }, r;
    };
    function N(e) {
      return N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, N(e);
    }
    function B(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (void 0, n = function (e, t) {
          if ("object" !== N(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var o = r.call(e, "string");
            if ("object" !== N(o)) return o;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(o.key), "symbol" === N(n) ? n : String(n)), o);
      }
      var n;
    }
    function V(e, t) {
      return V = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, V(e, t);
    }
    function W(e) {
      return W = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, W(e);
    }
    var z = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && V(e, t);
      }(u, e);
      var r,
        o,
        n,
        i,
        c = (n = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
            t = W(n);
          if (i) {
            var r = W(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);
          return function (e, t) {
            if (t && ("object" === N(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function (e) {
              if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return e;
            }(e);
          }(this, e);
        });
      function u(e) {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, u), c.call(this, e);
      }
      return r = u, (o = [{
        key: "render",
        value: function value() {
          return t().createElement(m, this.props);
        }
      }]) && B(r.prototype, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), u;
    }(t().Component);
    var $ = M(z);
    function U(e) {
      return U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, U(e);
    }
    function q(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (void 0, n = function (e, t) {
          if ("object" !== U(e) || null === e) return e;
          var r = e[Symbol.toPrimitive];
          if (void 0 !== r) {
            var o = r.call(e, "string");
            if ("object" !== U(o)) return o;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(o.key), "symbol" === U(n) ? n : String(n)), o);
      }
      var n;
    }
    function F(e, t) {
      return F = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, F(e, t);
    }
    function H(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Y(e) {
      return Y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, Y(e);
    }
    var X = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && F(e, t);
      }(s, e);
      var r,
        o,
        n,
        i,
        c = (n = s, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
            t = Y(n);
          if (i) {
            var r = Y(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);
          return function (e, t) {
            if (t && ("object" === U(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return H(e);
          }(this, e);
        });
      function s(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, s), t = c.call(this, e);
        var r = e.afterLoad,
          o = e.beforeLoad,
          n = e.scrollPosition,
          i = e.visibleByDefault;
        return t.state = {
          visible: i
        }, i && (o(), r()), t.onVisible = t.onVisible.bind(H(t)), t.isScrollTracked = Boolean(n && Number.isFinite(n.x) && n.x >= 0 && Number.isFinite(n.y) && n.y >= 0), t;
      }
      return r = s, (o = [{
        key: "componentDidUpdate",
        value: function value(e, t) {
          t.visible !== this.state.visible && this.props.afterLoad();
        }
      }, {
        key: "onVisible",
        value: function value() {
          this.props.beforeLoad(), this.setState({
            visible: !0
          });
        }
      }, {
        key: "render",
        value: function value() {
          if (this.state.visible) return this.props.children;
          var e = this.props,
            r = e.className,
            o = e.delayMethod,
            n = e.delayTime,
            i = e.height,
            c = e.placeholder,
            s = e.scrollPosition,
            l = e.style,
            a = e.threshold,
            f = e.useIntersectionObserver,
            p = e.width;
          return this.isScrollTracked || f && u() ? t().createElement(m, {
            className: r,
            height: i,
            onVisible: this.onVisible,
            placeholder: c,
            scrollPosition: s,
            style: l,
            threshold: a,
            useIntersectionObserver: f,
            width: p
          }) : t().createElement($, {
            className: r,
            delayMethod: o,
            delayTime: n,
            height: i,
            onVisible: this.onVisible,
            placeholder: c,
            style: l,
            threshold: a,
            width: p
          });
        }
      }]) && q(r.prototype, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), s;
    }(t().Component);
    X.propTypes = {
      afterLoad: n.PropTypes.func,
      beforeLoad: n.PropTypes.func,
      useIntersectionObserver: n.PropTypes.bool,
      visibleByDefault: n.PropTypes.bool
    }, X.defaultProps = {
      afterLoad: function afterLoad() {
        return {};
      },
      beforeLoad: function beforeLoad() {
        return {};
      },
      useIntersectionObserver: !0,
      visibleByDefault: !1
    };
    var A = X;
    function G(e) {
      return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, G(e);
    }
    var J = ["afterLoad", "beforeLoad", "delayMethod", "delayTime", "effect", "placeholder", "placeholderSrc", "scrollPosition", "threshold", "useIntersectionObserver", "visibleByDefault", "wrapperClassName", "wrapperProps"];
    function K(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, o);
      }
      return r;
    }
    function Q(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? K(Object(r), !0).forEach(function (t) {
          Z(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Z(e, t, r) {
      return (t = re(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function ee() {
      return ee = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
        return e;
      }, ee.apply(this, arguments);
    }
    function te(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, re(o.key), o);
      }
    }
    function re(e) {
      var t = function (e, t) {
        if ("object" !== G(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
          var o = r.call(e, "string");
          if ("object" !== G(o)) return o;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e);
      return "symbol" === G(t) ? t : String(t);
    }
    function oe(e, t) {
      return oe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, oe(e, t);
    }
    function ne(e) {
      return ne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, ne(e);
    }
    var ie = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && oe(e, t);
      }(u, e);
      var r,
        o,
        n,
        i,
        c = (n = u, i = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
            t = ne(n);
          if (i) {
            var r = ne(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);
          return function (e, t) {
            if (t && ("object" === G(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function (e) {
              if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return e;
            }(e);
          }(this, e);
        });
      function u(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, u), (t = c.call(this, e)).state = {
          loaded: !1
        }, t;
      }
      return r = u, (o = [{
        key: "onImageLoad",
        value: function value() {
          var e = this;
          return this.state.loaded ? null : function (t) {
            e.props.onLoad(t), e.props.afterLoad(), e.setState({
              loaded: !0
            });
          };
        }
      }, {
        key: "getImg",
        value: function value() {
          var e = this.props,
            r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function (e, t) {
              if (null == e) return {};
              var r,
                o,
                n = function (e, t) {
                  if (null == e) return {};
                  var r,
                    o,
                    n = {},
                    i = Object.keys(e);
                  for (o = 0; o < i.length; o++) r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                  return n;
                }(e, t);
              if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                for (o = 0; o < i.length; o++) r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
              }
              return n;
            }(e, J));
          return t().createElement("img", ee({}, r, {
            onLoad: this.onImageLoad()
          }));
        }
      }, {
        key: "getLazyLoadImage",
        value: function value() {
          var e = this.props,
            r = e.beforeLoad,
            o = e.className,
            n = e.delayMethod,
            i = e.delayTime,
            c = e.height,
            u = e.placeholder,
            s = e.scrollPosition,
            l = e.style,
            a = e.threshold,
            f = e.useIntersectionObserver,
            p = e.visibleByDefault,
            y = e.width;
          return t().createElement(A, {
            beforeLoad: r,
            className: o,
            delayMethod: n,
            delayTime: i,
            height: c,
            placeholder: u,
            scrollPosition: s,
            style: l,
            threshold: a,
            useIntersectionObserver: f,
            visibleByDefault: p,
            width: y
          }, this.getImg());
        }
      }, {
        key: "getWrappedLazyLoadImage",
        value: function value(e) {
          var r = this.props,
            o = r.effect,
            n = r.height,
            i = r.placeholderSrc,
            c = r.width,
            u = r.wrapperClassName,
            s = r.wrapperProps,
            l = this.state.loaded,
            a = l ? " lazy-load-image-loaded" : "",
            f = l || !i ? {} : {
              backgroundImage: "url(".concat(i, ")"),
              backgroundSize: "100% 100%"
            };
          return t().createElement("span", ee({
            className: u + " lazy-load-image-background " + o + a,
            style: Q(Q({}, f), {}, {
              color: "transparent",
              display: "inline-block",
              height: n,
              width: c
            })
          }, s), e);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
            t = e.effect,
            r = e.placeholderSrc,
            o = e.visibleByDefault,
            n = e.wrapperClassName,
            i = e.wrapperProps,
            c = this.getLazyLoadImage();
          return (t || r) && !o || n || i ? this.getWrappedLazyLoadImage(c) : c;
        }
      }]) && te(r.prototype, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), u;
    }(t().Component);
    ie.propTypes = {
      onLoad: n.PropTypes.func,
      afterLoad: n.PropTypes.func,
      beforeLoad: n.PropTypes.func,
      delayMethod: n.PropTypes.string,
      delayTime: n.PropTypes.number,
      effect: n.PropTypes.string,
      placeholderSrc: n.PropTypes.string,
      threshold: n.PropTypes.number,
      useIntersectionObserver: n.PropTypes.bool,
      visibleByDefault: n.PropTypes.bool,
      wrapperClassName: n.PropTypes.string,
      wrapperProps: n.PropTypes.object
    }, ie.defaultProps = {
      onLoad: function onLoad() {},
      afterLoad: function afterLoad() {
        return {};
      },
      beforeLoad: function beforeLoad() {
        return {};
      },
      delayMethod: "throttle",
      delayTime: 300,
      effect: "",
      placeholderSrc: null,
      threshold: 100,
      useIntersectionObserver: !0,
      visibleByDefault: !1,
      wrapperClassName: ""
    };
    var ce = ie;
  })(), module.exports = o;
})();